module.exports = __webpack_public_path__ + "../resources/img/ic_check_line_primary.3cff1647.svg";